export const specimenDetailEn = {
    xunjiadang:'Essential information',
    dingdangbianhao:'Order number',
    chuangjianshijian:'Creation time',
    jifang:'Sending party',
    shoufang:'Receiver',
    yangpingzhuantai:'Sample status',
    yangpingxinxi:'Sample information',
    yangpingmingcheng:'Sample name',
    shuliang:'Num',
    laiyuan:'source',
    shifouhuishou:'recycled',
    beizhu:'Remarks',
    wuliougenzhong:'Logistics tracking',
    xuhao:'Serial number',
    shoujianren:'Addressee',
    lianxihaoma:'Contact number',
    xiangxidizhi:'Detailed address',
    wulioudanghao:'Logistics number',
    wuliouleixing:'Logistics type',
    caozuo:'operation',
    caozuoxinxi:'Operation information',
    caozuoren:'Operator',
    zhengshuzhuantai:'Sample status',
    caozuoshijian:'Operation time',
    fanhuidingdang:'Return to Sample list'
}


// WEBPACK FOOTER //
// ./src/lang/member/specimenDetail/specimenDetailEn.js